import to from 'await-to-js'
import client from '@/api/client'
import reportDyEngagementMutation from '@/api/gql/_shared/dynamic-yield/mutation/report-dy-engagement.gql'
import reportDyEventsMutation from '@/api/gql/_shared/dynamic-yield/mutation/report-dy-events.gql'
import { onDOMContentLoaded } from '@/helpers/event'

const DELAY_UNTIL_NEXT_REPORT = 1000
const hasReportedToDyRecently = {}
const hasAlreadyReportedToDy = {}

function makeDyEventsMutation(events) {
  return to(
    client
      .mutate({
        mutation: reportDyEventsMutation,
        variables: { events },
      })
      .then(({ data }) => data)
  )
}

export default {
  namespaced: true,

  actions: {
    reportEngagementToDy(context, dyCampaign) {
      if (!dyCampaign) return

      const { variationId, decisionId } = dyCampaign
      const id = `${variationId}__${decisionId}`
      if (!variationId || !decisionId || hasReportedToDyRecently[id]) return

      client.mutate({
        mutation: reportDyEngagementMutation,
        variables: { variations: [variationId], decisionId },
      })
      hasReportedToDyRecently[id] = true
      setTimeout(() => (hasReportedToDyRecently[id] = false), DELAY_UNTIL_NEXT_REPORT)
    },

    async reportEventsToDy(context, events) {
      await onDOMContentLoaded()
      let shouldReport = true

      events = events.map(event => {
        if (event.once === true) {
          shouldReport = !hasAlreadyReportedToDy[event.name]
          hasAlreadyReportedToDy[event.name] = true
          delete event.once
        }
        return event
      })
      if (shouldReport) {
        const [error, data] = await makeDyEventsMutation(events)
        if (error || !data?.reportDyEvents?.success) {
          // retry at least once
          setTimeout(async () => await makeDyEventsMutation(events), DELAY_UNTIL_NEXT_REPORT)
        }
      }
    },
  },
}
